import { render, staticRenderFns } from "./wizardCompletion.vue?vue&type=template&id=0960d7b0&scoped=true"
import script from "./wizardCompletion.vue?vue&type=script&lang=js"
export * from "./wizardCompletion.vue?vue&type=script&lang=js"
import style0 from "./wizardCompletion.vue?vue&type=style&index=0&id=0960d7b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960d7b0",
  null
  
)

export default component.exports